import React, { useState, Fragment,useContext, useEffect } from 'react';
import Dashboard from '@uppy/react/lib/Dashboard'
import Uppy from '@uppy/core'
import {ExcelRenderer} from '../components/ExcelRenderer'

import {RowsContext} from '../context/RowsContext'
import axios from 'axios'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import Tabla from '../components/tabla2';
import './css/styles.css'
import { AuthContext } from '../context/Auth';
import CircularProgress from '@material-ui/core/CircularProgress'
import { API_URL } from '../context/constants';
import {token} from '../utils/utils'
import { Button } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
// import Upppy from '../components/Uppy';

const uppy = Uppy({
    debug: false,
    autoProceed: false,
    restrictions: {
        maxNumberOfFiles: null,
       allowedFileTypes: ['.xlsx','.xls'],
      },
  })

uppy.on('complete', (result) => {
    if(result.successful.length>0){
      result.successful.forEach((item)=>{
        ExcelRenderer(item.data, async (err, resp) => {
          if(err){
            console.log(err);            
          }
          else{
            resp.rows.shift();
            const arrayLimpio=resp.rows.filter((item)=>item.length!==0);
            await axios.post(`${API_URL}/usuarios`,{data:arrayLimpio},{
              headers:{
                token:token
              }
            })
          }
        });   
      })

      const items=uppy.getFiles()
      items.forEach((item)=>{
        uppy.removeFile(item.id)
      })
    }
  })
  
const UsuarioAdmin = () => {
  const {rows,setRows}=useContext(RowsContext);
  const [rutas,setRutas]=useState([])
  const [loading,setLoading]=useState(true);
  const [subirExcel,setSubirExcel]=useState(0);
  const {token}=useContext(AuthContext);

  useEffect(()=>{
    if (!token)
        return 
    const getUsuarios=async ()=>{
      
      setLoading(true)
      function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }
      await sleep(3500);
      const r=await axios.get(`${API_URL}/usuarios`,{
        headers:{
          token
        }
      });
   
      let res=await axios.get(`${API_URL}/rutas`,{
        headers:{
          token
        }
      });
      setRutas(res.data)
      if (res.length!==0){
        r.data.map(item=>{
          const ruta=res.data.filter(item2=>item.ruta===item2.id);
          if(ruta.length>0)
          item.ruta=ruta[0].nombreRuta;
          item.alta?item.alta='Alta':item.alta='Baja';
          return item;
        })  
      }
      setRows(r.data);
      setLoading(false)
    }
    getUsuarios()
    // eslint-disable-next-line
  },[subirExcel,token])

uppy.on('complete',()=>
{
  setSubirExcel(subirExcel+1)
})
const exportExcel=()=>{
  const fileName="usuarios.xlsx";
  // const rutasExcel=rutas.map(item=>{
  //   let p="";
  //   item.paradas.forEach(item=>{
  //     p=p+item.parada+"-"+item.horaParada+"/"
    
  //   })
  //   return({
  //     NombreRuta:item.nombreRuta,
  //     InicioDeLaRuta:item.inicioRuta,
  //     HoraDeInicioDeLaRuta:item.horaInicio,
  //     FinDeLaRuta:item.finRuta,
  //     HoraDeFinDeLaRuta:item.horaFin,
  //     InicioServicio:item.inicioServicio,
  //     Paradas:p
  //   })
  // });
  const ws=XLSX.utils.json_to_sheet(rows);
  const wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Usuarios');
  XLSX.writeFile(wb, fileName);
  
}
  
    return (
      !token||loading?<CircularProgress />:
      <Fragment>
        { rows.length>0 ?
        <Fragment>
           <div style={{display:'flex',margin:30,justifyContent:'flex-end'}}>
              <Button onClick={()=>exportExcel()}>
              <FileExcelOutlined />
              Descargar Usuarios
              </Button>
            </div>
          <Tabla rows={rows} setRows={setRows} rutas={rutas}/>

          
          
        </Fragment>
        : 
        <Fragment> </Fragment>}

        <Dashboard
        uppy={uppy}
        height={300}
        width='90%'
        
        />
      </Fragment>
      
      
     );
}
 
export default UsuarioAdmin;
